import { useCallback } from 'react';
import useWorkspaceID from './use-workspace-id';

/**
 * Creates a function that you can invoke to construct a workspace specifc URL
 * for navigating to a specific resource
 */
export default function useLazyWorkspaceUrl(): (href: string) => string {
  const workspaceID = useWorkspaceID();

  const createWorkspaceUrl = useCallback(
    (href: string) => {
      // When server rendered or on the first render on the client the workspace ID will be an
      // empty string. We pass back a "/" because if we pass back an empty string NextJs converts
      // that into the current URL and then the server render href will not be the same as the client,
      // i.e. the server will be "" and the client will be the current route. By providing a "/" NextJs
      // doesn't do this conversion and the client and server hrefs are the same so no error is thrown.
      if (!workspaceID) return '/';

      const workspaceAwareHref = `/${workspaceID}/${href}`;

      return workspaceAwareHref;
    },
    [workspaceID]
  );

  return createWorkspaceUrl;
}
